import { render, staticRenderFns } from "./taskLocationDashboardBox.vue?vue&type=template&id=26a334a8&scoped=true&"
import script from "./taskLocationDashboardBox.vue?vue&type=script&lang=js&"
export * from "./taskLocationDashboardBox.vue?vue&type=script&lang=js&"
import style0 from "./taskLocationDashboardBox.vue?vue&type=style&index=0&id=26a334a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26a334a8",
  null
  
)

export default component.exports